'use strict';

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var suspectProtoRx = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/;
var suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;

function parse(text, reviver, options) {
  // Normalize arguments
  if (options == null) {
    if (reviver !== null && typeof reviver === 'object') {
      options = reviver;
      reviver = undefined;
    } else {
      options = {};
    }
  }

  var protoAction = options.protoAction || 'error';
  var constructorAction = options.constructorAction || 'error'; // BOM checker

  if (text && text.charCodeAt(0) === 0xFEFF) {
    text = text.slice(1);
  } // Parse normally, allowing exceptions


  var obj = JSON.parse(text, reviver); // options: 'error' (default) / 'remove' / 'ignore'

  if (protoAction === 'ignore' && constructorAction === 'ignore') {
    return obj;
  } // Ignore null and non-objects


  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (protoAction !== 'ignore' && constructorAction !== 'ignore') {
    if (suspectProtoRx.test(text) === false && suspectConstructorRx.test(text) === false) {
      return obj;
    }
  } else if (protoAction !== 'ignore' && constructorAction === 'ignore') {
    if (suspectProtoRx.test(text) === false) {
      return obj;
    }
  } else {
    if (suspectConstructorRx.test(text) === false) {
      return obj;
    }
  } // Scan result for proto keys


  scan(obj, {
    protoAction: protoAction,
    constructorAction: constructorAction
  });
  return obj;
}

function scan(obj) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$protoAction = _ref.protoAction,
      protoAction = _ref$protoAction === void 0 ? 'error' : _ref$protoAction,
      _ref$constructorActio = _ref.constructorAction,
      constructorAction = _ref$constructorActio === void 0 ? 'error' : _ref$constructorActio;

  var next = [obj];

  while (next.length) {
    var nodes = next;
    next = [];

    var _iterator = _createForOfIteratorHelper(nodes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;

        if (protoAction !== 'ignore' && Object.prototype.hasOwnProperty.call(node, '__proto__')) {
          // Avoid calling node.hasOwnProperty directly
          if (protoAction === 'error') {
            throw new SyntaxError('Object contains forbidden prototype property');
          }

          delete node.__proto__; // eslint-disable-line no-proto
        }

        if (constructorAction !== 'ignore' && Object.prototype.hasOwnProperty.call(node, 'constructor')) {
          // Avoid calling node.hasOwnProperty directly
          if (constructorAction === 'error') {
            throw new SyntaxError('Object contains forbidden prototype property');
          }

          delete node.constructor;
        }

        for (var key in node) {
          var value = node[key];

          if (value && typeof value === 'object') {
            next.push(node[key]);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}

function safeParse(text, reviver) {
  try {
    return parse(text, reviver);
  } catch (ignoreError) {
    return null;
  }
}

module.exports = {
  parse: parse,
  scan: scan,
  safeParse: safeParse
};